import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { ParkingBillingSettingRequest } from '../api/requests/parking-billing-setting-request.ts';
import { updateParkingBillingSetting } from '../api/parking-billing-setting.ts';

export default function useUpdateBillingSetting(): UseMutationResult<
  string,
  Error,
  { id: string; request: ParkingBillingSettingRequest }
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, request }) => updateParkingBillingSetting(id, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parkingBillingSettings'] });
    },
  });
}
